// extracted by mini-css-extract-plugin
module.exports = {"signOutLink":"SideMenu_signOutLink__3D9mS"};